import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { Button, Divider, Grid, IconButton, Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import EditGeneralInfo from './talentInfoEdit';
import ResumeUploader from '../../components/uploadResume';


const ColorButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText('#29479a'),
        backgroundColor: '#29479a',
        width: 'auto', 
        minWidth: '150px',
        borderRadius: '25px',
        '&:hover': {
        backgroundColor: '#294780',
        },
    },
}))(Button);

function calc_age (birthday) {
    let age = 0;
    const today = new Date();
    const year = Number(birthday.slice(0, 4));
    const month = Number(birthday.slice(5, 7));
    const day = Number(birthday.slice(8, 10));

    if(! month) {
        return false;
    }

    if ((today.getMonth() + 1) > month) {
        age = today.getFullYear() - year;
    }else if ((today.getMonth() + 1) === month){
        age = (today.getDate() >= day)
            ? today.getFullYear() - year
            : today.getFullYear() - year - 1;
    }else {
        age = today.getFullYear() - year - 1;
    }

    return (age > 0)? age : 0;
}

function GeneralInfo (props){
    return (
        <>
            <Grid container
            direction="row"
            justify="flex-end"
            alignItems="center">
                <Grid item lg={4} md={6} sm={6}>
                    <IconButton 
                    aria-label="github.com" 
                    target='_blank'
                    href={ 
                        props.talent.github.includes('https://')
                        ? props.talent.github
                        : `https://${ props.talent.github }`
                    }
                    >
                        <GitHubIcon style={{ fontSize: 40 }}/>
                    </IconButton>
                    <IconButton
                    aria-label="Linkedin.com" 
                    target='_blank'
                    href={ 
                        (props.talent.linkedin.includes('https://'))
                        ? props.talent.linkedin
                        : `https://${ props.talent.linkedin }`
                    }
                    >
                        <LinkedInIcon color='primary' style={{ fontSize: 50 }}/>
                    </IconButton>
                    <ColorButton onClick={props.update}>
                        Edit Profile
                    </ColorButton>
                </Grid>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid container
            direction="row"
            justify="space-between"
            alignItems="center">
                <Grid item xs={12}>
                    <h4><strong>General Info</strong></h4>
                </Grid>
                <Grid item xs={12} md={6} sm={12} lg={6}>
                    <p><strong>Name: </strong>{props.talent && props.talent.name}</p>
                    <p><strong>Role: </strong> {props.talent && props.talent.role}</p>
                    <p><strong>Nationality: </strong> {props.talent && props.talent.nationality}</p>
                </Grid>
                <Grid item xs={12} md={6} sm={12} lg={6}>
                    <p><strong>Age: </strong> {props.talent && calc_age(props.talent.birthday)}</p>
                    <p><strong>Experience: </strong> {props.talent && props.talent.experience}</p>
                    <p><strong>Location: </strong> {props.talent && props.talent.location}</p>
                </Grid>
                <Grid item xs={12}>
                    <Paper elevation={0}>
                        <p><strong>Bio: </strong>
                            <br/> {props.talent && props.talent.bio}
                        </p>
                    </Paper>
                </Grid>
            </Grid>
            <Divider />
            <Grid container
            direction="row"
            justify="space-between"
            alignItems="center">
                <Grid item xs={12}>
                    <h4 className="mt-1"><strong>Contact Info</strong></h4>
                </Grid>
                <Grid item xs={12} md={6} sm={12} lg={6}>
                    <p><strong>Mail: </strong> {props.talent && props.talent.email}</p>
                </Grid>
                <Grid item xs={12} md={6} sm={12} lg={6}>
                    <p><strong>Phone: </strong> {props.talent && props.talent.phone}</p>
                </Grid>
            </Grid>
        </>

    );
}

const TalentlInfo = () => {
    const { user } = useAuth0();
    const [edit, SetEdit] = useState(false);
    const [update, setUpdate] = useState(false);
    const [loading, setLoading] = useState(true);

    const refreshComponent = () => {
        setUpdate(true)
    }

    const [talent, SetTalent] = useState(
        {
            'id': user.sub,
            'name': user.name,
            'role': '',
            'experience': '',
            'nationality': '',
            'location': '',
            'email': user.email,
            'phone': '',
            'birthday': '',
            'github': '',
            'linkedin': '',
            'updated_cv': '',
            'cv_url': ''
        }
    )

    useEffect(() => {
        const fetch_talent = async() => {
            await fetch(process.env.REACT_APP_IP + `/talent/data/${user.sub}`, {
                method: 'GET'
            }).then((res) => res.json())
            .then((res) => {
                SetTalent(res.talent)
                setUpdate(false);
                setLoading(false);
            })
        }
        fetch_talent()
    }, [user, update])

    const handleEdit = () => {
        SetEdit(! edit)
    }

    if(loading) {
        return <></>
    }
    else{
        return (
            <>
                {!edit && <GeneralInfo 
                            update={handleEdit} 
                            talent={talent}/>
                }
                {edit && <EditGeneralInfo 
                            update={handleEdit} 
                            talent={talent}
                            refresh={refreshComponent}/>
                }
                <Divider />
                <ResumeUploader talent={talent}/>
            </>
        );
    }
}
 
export default TalentlInfo;